// extracted by mini-css-extract-plugin
export default {"HomeModuleInfo":"page_HomeModuleInfo__gxYAy","uzor":"page_uzor__TaHmo","container":"page_container__gj1+k","imgBox":"page_imgBox__NY8xf"};